import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import NotificationIcon from "../assets/icon/NotificationIcon";
import SettingIcon from "../assets/icon/SettingIcon";
import { useAuth } from "../context/AuthContext";

export const Header = () => {
  const location = useLocation();
  const { user, logout } = useAuth();
  const [logoSrc, setLogoSrc] = React.useState('/mainLogo.svg');
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.role === 'PROVIDER' && user?.clinic) {
      setLogoSrc(`/clinic/${user.clinic}.png`);
    } else {
      setLogoSrc('/mainLogo.svg');
    }
  }, [user]);

  useEffect(() => {
    const onDocClick = (e: MouseEvent) => {
      if (!userMenuRef.current) return;
      if (userMenuRef.current.contains(e.target as Node)) return;
      setUserMenuOpen(false);
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  const isLayoutRoute = location.pathname.startsWith("/layout");
  const isPatientLayoutRoute = location.pathname.startsWith("/user-layout");

  const handleLogout = () => {
    try {
      logout();
    } catch (err) {
      console.error("Logout failed", err);
    }

    if (user?.role === "PROVIDER") navigate("/provider-login");
    else if (user?.role === "patient") navigate("/patient-login");
    else navigate("/");
  };

  // final displayed name
  const displayName =
    user?.role === "PROVIDER"
      ? `Dr. ${user?.name || ""}`
      : user?.name || "User";

  return (
    <div className="header">
      <div className="logo">
        <img
          src={logoSrc}
          alt="Logo"
          onError={(e: any) => { e.currentTarget.src = '/mainLogo.svg'; }}
        />
      </div>

      {/* ---------------- PROVIDER HEADER ---------------- */}
      {isLayoutRoute && (
        <div className="loginDetails" style={{ display: "flex", gap: "36px", alignItems: "center" }}>
          <input type="text" className="search" placeholder="Type Here..." />

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <SettingIcon width={20} height={20} color="#A0AEC0" /> |
            <NotificationIcon width={20} height={20} color="#A0AEC0" />
          </div>

          <div
            style={{ display: "flex", alignItems: "center", gap: "10px", position: 'relative' }}
            ref={userMenuRef}
          >
            <img
              src={user?.avatar || "https://upload.wikimedia.org/wikipedia/commons/9/99/Sample_User_Icon.png"}
              alt={`${displayName} avatar`}
              width={32}
              height={32}
              style={{ borderRadius: 25 }}
            />

            <button
              type="button"
              onClick={() => setUserMenuOpen(s => !s)}
              style={{ background: "transparent", border: "none", cursor: "pointer", fontSize: 14, color: "#A0AEC0" }}
            >
              {displayName}
            </button>

            {userMenuOpen && (
              <div style={{
                position: "absolute",
                right: 0,
                top: "calc(100% + 8px)",
                background: "#fff",
                border: "1px solid #e0e0e0",
                padding: 8,
                borderRadius: 6,
                zIndex: 2000
              }}>
                <button
                  type="button"
                  style={{ width: "100%", textAlign: "left", padding: "6px 12px", background: "transparent", border: "none", cursor: "pointer" }}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            )}
          </div>

          <svg width="12" height="8" viewBox="0 0 12 8">
            <path d="M11 1.5L6 6.5L1 1.5" stroke="#A0AEC0" strokeWidth="2" />
          </svg>
        </div>
      )}

      {/* ---------------- PATIENT HEADER ---------------- */}
      {isPatientLayoutRoute && (
        <div className="loginDetails" style={{ display: "flex", gap: "36px", alignItems: "center" }}>
          <input type="text" className="search" placeholder="Type Here..." />

          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <SettingIcon width={20} height={20} color="#A0AEC0" /> |
            <NotificationIcon width={20} height={20} color="#A0AEC0" />
          </div>

          <div
            ref={userMenuRef}
            style={{ display: "flex", alignItems: "center", gap: "10px", position: "relative" }}
          >
            <img
              src={user?.avatar || "https://upload.wikimedia.org/wikipedia/commons/9/99/Sample_User_Icon.png"}
              alt={`${displayName} avatar`}
              width={32}
              height={32}
              style={{ borderRadius: 25 }}
            />

            <button
              type="button"
              onClick={() => setUserMenuOpen(s => !s)}
              style={{ background: "transparent", border: "none", cursor: "pointer", fontSize: 14, color: "#A0AEC0" }}
            >
              {displayName}
            </button>

            {userMenuOpen && (
              <div style={{
                position: "absolute", right: 0, top: "calc(100% + 8px)",
                background: "#fff", border: "1px solid #e0e0e0",
                padding: 8, borderRadius: 6, zIndex: 2000
              }}>
                <button
                  type="button"
                  style={{ width: "100%", textAlign: "left", padding: "6px 12px", background: "transparent", border: "none", cursor: "pointer" }}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            )}
          </div>

          <svg width="12" height="8" viewBox="0 0 12 8">
            <path d="M11 1.5L6 6.5L1 1.5" stroke="#A0AEC0" strokeWidth="2" />
          </svg>
        </div>
      )}
    </div>
  );
};
